
import { mapGetters } from "vuex"
import { VEmojiPicker } from "v-emoji-picker"
import linkifyString from "linkify-string"
// import AppChatStickers from "../AppChatStickers.vue"
import {
  client, isStickerMessage, getStickerPath, renderText, wrapInReply, cleanReply,
} from "@/utils/chat"

export default {
  components: {
    VEmojiPicker,
    // AppChatStickers,
  },

  props: {
    defaultChat: { type: String, default: null },
  },

  data () {
    return {
      messages: [],
      message: "",
      chats: {},
      chat: null,
      socket: null,
      searchQuery: "",
      fuse: null,
      showEmojiPicker: false,
      showStickerPicker: false,
      isConnected: false,
      replyTo: null,
    }
  },

  computed: {
    ...mapGetters("user", ["user"]),
    token () {
      return this.$auth.strategy.token.get().replace("Bearer ", "")
    },
    chatsCount () {
      return Object.keys(this.chats).length
    },
    filteredChats () {
      if (this.searchQuery === "")
        return this.chats

      return this.fuse.search(this.searchQuery).map(item => item.item.data)
    },
    replyToName () {
      const { replyTo } = this
      return replyTo ? this.$fmt.name(replyTo.author) : ""
    },
    replyToText () {
      const { replyTo } = this
      return replyTo ? cleanReply(replyTo.text, { strip: true }) : ""
    },
  },

  mounted () {
    this.client = client("private_chat", this.token)
    this.client.addOnMessageListener("connect", () => {
      this.client.send("list_chats")
    })

    this.client.addOnMessageListener("list_chats", (message) => {
      message.data.forEach((chat) => {
        if (typeof this.chats[chat.id] === "undefined") {
          if (chat.type === "channel" || !chat.otherParticipant) return
          chat.loaded = false
          chat.messages = [chat.lastMessage].filter(item => item !== null)
          this.$set(this.chats, chat.id, chat)
        }
      })

      const { default: Fuse } = require("fuse.js")
      this.fuse = new Fuse(
        Object.values(this.chats).map((item) => {
          return { title: item.title, data: item }
        }),
        {
          threshold: 0.1,
          keys: ["title.en", "title.ru"],
        },
      )

      if (this.defaultChat !== null && this.chats[this.defaultChat])
        this.setChat(this.chats[this.defaultChat])

      this.isConnected = true
    })

    this.client.addOnMessageListener("get_messages", (message) => {
      const messages = message.data.messages
      if (messages.length === 0)
        return

      const id = messages[0].chat
      if (!this.chats[id])
        return

      this.chats[id].messages.length = 0
      for (const item of messages)
        this.chats[id].messages.push(item)

      this.chats[id].loaded = true
      this.scrollAndFocus()
    })

    this.client.addOnMessageListener("get_message", (message) => {
      const messageChat = message.data.chat

      if (typeof this.chats[messageChat] === "undefined") {
        this.client.send("list_chats")

        return
      }

      if (this.chat === null || messageChat !== this.chat.id)
        this.chats[messageChat].unreadCount++
      else
        this.client.send("mark_read_messages", { chatId: this.chat.id })

      this.chats[messageChat].messages.push(message.data)
    })

    this.client.addOnCloseListener(() => {
      this.isConnected = false
    })

    this.client.connect(this.$config.chatUrl)
  },

  destroyed () {
    this.$store.commit("chat/SET_CURRENT_CHAT", "")
    this.client.close()
  },

  methods: {
    renderText,
    isStickerMessage,
    getStickerPath,
    cleanReply,

    renderTextWithLinks (text) {
      // console.log()
      // console.log(text)
      const linkified = linkifyString(text, {
        // FIXME: @@@<url>@@@<*>
        validate: val => !val.includes("@@@"),
        target: "_blank",
      })
      // console.log(linkified)
      const rendered = renderText(linkified)
      // console.log(rendered)
      return rendered
    },

    isMyMessage (message) {
      return message.author.userId === this.user?.id ||
        message.author.id === this.user?.id
    },

    sendMessage (chat, text) {
      const { client, replyTo } = this
      let message = text
      if (!message || !client || !this.isConnected) return

      const rendered = renderText(message)
      if (!rendered.trim()) return

      if (replyTo) {
        const replyText = wrapInReply(replyTo.text)
        message = replyText + message
      }

      const data = {
        text: message,
        chatId: chat.id,
      }
      client.send("send_message", data)

      this.message = ""
      this.replyTo = null
      this.showEmojiPicker = false
      /* this.$nextTick(() => this.scrollToBottom(true)) */

      const author = Object.assign({}, this.user)
      this.chat.messages.push(
        Object.assign({}, data, {
          creationTime: Date.now(),
          author,
        }),
      )
    },

    setChat (chat) {
      this.messages = chat.messages
      this.chat = chat
      this.$store.commit("chat/SET_CURRENT_CHAT", chat.id)

      if (!chat.loaded)
        this.client.send("get_messages", { chatId: chat.id, limit: 100 })
      else
        this.scrollAndFocus()

      window.history.replaceState("", "", `/account/chat/${chat.id}`)

      if (chat.unreadCount > 0) {
        this.client.send("mark_read_messages", { chatId: chat.id })
        this.$store.commit("chat/DECREASE_UNREAD_COUNT", chat.unreadCount)
      }

      chat.unreadCount = 0
    },

    scrollAndFocus () {
      this.$nextTick(() => {
        const chatWindowElement = this.$refs["chat-window"]?.$el
        if (!chatWindowElement) return
        chatWindowElement.scrollTop = chatWindowElement.scrollHeight

        this.$refs["message-input"].focus({
          preventScroll: true,
        })
      })
    },

    truncateString (string, maxLength) {
      if (string.length <= maxLength)
        return string

      return `${string.substring(0, maxLength)}...`
    },

    getLastMessage (chat) {
      const messagesCount = chat.messages.length

      if (messagesCount === 0)
        return null

      return chat.messages[messagesCount - 1]
    },

    sortChats (chats) {
      return Object.keys(chats)
        .sort((a, b) => {
          const chatA = chats[a]
          const chatB = chats[b]

          if (chatA.type === "private_chat" && chatB.type === "channel")
            return 1

          if (chatB.type === "private_chat" && chatA.type === "channel")
            return -1

          const lastMessageA = this.getLastMessage(chatA)
          const lastMessageB = this.getLastMessage(chatB)

          if (lastMessageA === null && lastMessageB === null)
            return 0

          if (lastMessageB === null)
            return -1

          if (lastMessageA === null)
            return 1

          return lastMessageB.creationTime - lastMessageA.creationTime
        })
        .map(key => chats[key])
    },

    addEmoji (emoji) {
      this.message += emoji.data
      this.showEmojiPicker = false
      this.scrollAndFocus()
    },

    sendSticker (sticker) {
      this.sendMessage(this.chat, `~~${sticker}~~`)
    },

    reply (message) {
      this.replyTo = message
      this.scrollAndFocus()
    },

    onEnter (event) {
      if (event.shiftKey || event.ctrlKey || event.metaKey)
        this.message += "\n"
      else
        this.sendMessage(this.chat, this.message)
    },
  },
}
